import React from 'react'
import DataSourceContainer from '../../../../Components/Tables/DataTables/DataSource'

export default function DataSource() {
  return (
    <div className='page-body'>
      <DataSourceContainer />
    </div>
  )
}